import {Injectable} from '@angular/core';
import {ShipmentListResponse} from '../shipment-list-response';
import { ActivatedRouteSnapshot, convertToParamMap } from '@angular/router';
import {ShipmentListService} from '../shipment-list.service';
import {ShipmentQueryParameters} from '../shipment-query-parameters';
import {Observable} from 'rxjs/internal/Observable';

@Injectable()
export class DeviatedShipmentListResolver  {
  constructor(private shipmentListService: ShipmentListService) {
  }

  resolve(route: ActivatedRouteSnapshot): Promise<ShipmentListResponse> {
    const params = convertToParamMap(route.queryParams);

    const page = params.has('page') ? params.get('page') : 1;
    const pageSize = params.has('pageSize') ? +params.get('pageSize') : 20;

    let offset = 0;

    if (page !== undefined) {
      offset = pageSize * (+page - 1);
    }

    const parameters: ShipmentQueryParameters = {
      carrierId: null,
      departmentId: null,
      offset: offset,
      count: pageSize,
      orderStatus: params.get('status'),
      includeShipmentsWithoutOrderBinding: true,
      sortBy: params.get('sortBy'),
      sortDirection: params.get('sortDirection'),
      number: null,
      receiverName: null,
      senderName: null,
      updatedAfter: null,
      updatedUntil: null
    };

    return this.shipmentListService.getDeviatedShipments(parameters);
  }
}
